<template>
        <div class="table__responsive">
            <table class="table table__responsive">
                <thead v-if="!loadingDocuments && documentVersions.length" >
                    <tr>
                        <th>{{$t('dashboard.documents.versions_table.header.document')}}</th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingDocuments" :key="'loading'" class="table--loading">
                        <td colspan="3">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('dashboard.documents.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingDocuments && !documentVersions.length" :key="'no-documents'" class="table--empty">
                        <td colspan="3">
                            <div class="text-center">{{$t('dashboard.documents.table.no_documents')}}</div>
                        </td>
                    </tr>
                    <template v-if="!loadingDocuments && documentVersions.length">
                        <tr v-for="(document, index) in documentVersions" :key="document.name + index">
                            <td>{{ document.name }}</td>
                            <td>
                                <span v-tooltip.bottom="documentTooltipContent(document)" class="table__icon icons icon-info"></span>
                            </td>
                            <td><span @click="downloadDocument(document)" v-tooltip.bottom="$t('dashboard.documents.table.download')" class="table__icon icons icon-cloud-download"></span></td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import { saveFile } from '@/helpers';
    import ReturnedDocument from '@/models/ReturnedDocument';

    @Component
    export default class DocumentVersionsTable extends Vue {
        name = 'document-versions-table';

        @Prop()
        originalDocument;

        loadingDocuments = false;
        documentVersions = [];

        mounted() {
            this.fetchDocumentVersions();
        }

        fetchDocumentVersions() {
            this.loadingDocuments = true;
            const ReturnedDocuments = ReturnedDocument.makeModel(`/trajectories/${this.trajectory.id}/files/${this.originalDocument.id}/versions`);
            ReturnedDocuments.collection()
                .then(({items, meta}) => {
                    this.documentVersions = items;
                })
                .catch(err => {
                    let errors = err.response && err.response.data ? err.response.data : err;
                    this.$notify.error(this.$t('notify.returned_document.fetch_error'));
                    this.$modal.hide(this.name);
                })
                .then(() => this.loadingDocuments = false);
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        documentTooltipContent(document) {
            let clientApproved = this.$t('dashboard.documents.versions_table.not_requested');
            let employerApproved = this.$t('dashboard.documents.versions_table.not_requested');

            if (document.client_approval.requested) {
                clientApproved = this.$t('dashboard.documents.versions_table.requested');

                if (document.client_approval.approved !== null) {
                    if (document.client_approval.approved == false) {
                        clientApproved = this.$t('dashboard.documents.versions_table.rejected');
                        clientApproved = clientApproved + ': ' +  document.client_approval.reason || '-';
                    } else {
                        clientApproved = this.$t('dashboard.documents.versions_table.approved');
                    }
                }
            }

            if (document.employer_approval.requested) {
                employerApproved = this.$t('dashboard.documents.versions_table.requested');

                if (document.employer_approval.approved !== null) {
                    if (document.employer_approval.approved == false) {
                        employerApproved = this.$t('dashboard.documents.versions_table.rejected');
                        employerApproved = employerApproved + ': ' +  document.employer_approval.reason || '-';
                    } else {
                        employerApproved = this.$t('dashboard.documents.versions_table.approved');
                    }
                }
            }

            let tooltipContent = this.$t('dashboard.documents.versions_table.document_info', { sender: document.uploader.name, date: document.date });
            tooltipContent += '<br/><br/>' + this.$t('dashboard.documents.versions_table.client_approval') + ':<br/>';
            tooltipContent +=  clientApproved + '<br/>';
            tooltipContent += '<br/>' + this.$t('dashboard.documents.versions_table.employer_approval') + ':<br/>';
            tooltipContent +=  employerApproved + '<br/>';
            return tooltipContent;
        }

        downloadDocument(document) {
            const url = `trajectories/${this.trajectory.id}/files/${this.originalDocument.id}/versions/${document.id}/download`;
            return this.axios.get(url, {responseType: 'blob'})
                .then(
                    res => saveFile(res.data, document.name, document.mime),
                    err => this.$notify.error(this.$t('notify.download_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/DocumentVersionsTable.vue